export class DynamoDbLocalSecondaryIndex {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "indexName",
            "baseName": "indexName",
            "type": "string",
            "format": ""
        },
        {
            "name": "keySchema",
            "baseName": "keySchema",
            "type": "Array<DynamoDbIndexKeySchemaElement>",
            "format": ""
        },
        {
            "name": "projection",
            "baseName": "projection",
            "type": "DynamoDbIndexProjection",
            "format": ""
        },
        {
            "name": "indexSizeBytes",
            "baseName": "indexSizeBytes",
            "type": "number",
            "format": "int64"
        }
    ];
    static getAttributeTypeMap() {
        return DynamoDbLocalSecondaryIndex.attributeTypeMap;
    }
    constructor() {
    }
}
